(function () {
  'use strict';
  var routes = (window.velora && window.velora.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };
  var cartType = (window.velora && window.velora.cartType) || 'drawer';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function toast(msg) {
    var t = $('#VeloraToast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  var overlay;
  function ensureOverlay() {
    overlay = $('.overlay');
    if (!overlay) { overlay = document.createElement('div'); overlay.className = 'overlay'; document.body.appendChild(overlay); }
    overlay.onclick = closeAll;
  }
  function open(id) {
    ensureOverlay();
    var d = document.getElementById(id); if (!d) return;
    closeAll(); d.classList.add('is-open'); overlay.classList.add('is-open'); document.body.classList.add('no-scroll');
    d.setAttribute('aria-hidden', 'false');
    var f = d.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeAll() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      if (o.getAttribute('data-open') === 'CartDrawer' && cartType === 'page') return;
      e.preventDefault(); open(o.getAttribute('data-open'));
      if (o.getAttribute('data-open') === 'CartDrawer') refreshCart();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
    var st = e.target.closest('[data-search-toggle]');
    if (st) { e.preventDefault(); var b = $('#SearchBar'); if (b) { b.classList.toggle('is-open'); var i = b.querySelector('input'); if (i && b.classList.contains('is-open')) i.focus(); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Cart (Shopify AJAX API + Section Rendering) ---------- */
  function sectionIds() {
    var ids = ['cart-drawer'];
    if ($('[data-cart-page]')) ids.push($('[data-cart-page]').getAttribute('data-section-id'));
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var target = document.getElementById('shopify-section-' + id);
      var src = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
      if (!target || !src) return;
      // Keep drawer open state
      var wasOpen = !!target.querySelector('.drawer.is-open');
      target.innerHTML = src.innerHTML;
      if (wasOpen) { var d = target.querySelector('.drawer'); if (d) d.classList.add('is-open'); }
    });
    updateCount();
  }
  function updateCount() {
    fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.setAttribute('data-count', cart.item_count); });
      }).catch(function () {});
  }
  function refreshCart() {
    var ids = sectionIds();
    fetch(routes.root_url.replace(/\/$/, '') + '/?sections=' + ids.join(','))
      .then(function (r) { return r.json(); }).then(applySections).catch(function () {});
  }
  function changeLine(line, qty, el) {
    var wrap = el && el.closest('[data-cart-items]'); if (wrap) wrap.classList.add('is-updating');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'Could not update bag'); refreshCart(); return; }
        applySections(res.j.sections);
      }).catch(function () { toast('Could not update bag'); })
      .finally(function () { if (wrap) wrap.classList.remove('is-updating'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (b && b.closest('[data-cart-items]')) {
      e.preventDefault();
      var line = parseInt(b.getAttribute('data-line'), 10);
      var cur = parseInt(b.getAttribute('data-qty'), 10);
      changeLine(line, Math.max(0, cur + parseInt(b.getAttribute('data-qty-change'), 10)), b);
      return;
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0, rm); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cart-items] input[data-line]');
    if (i) changeLine(parseInt(i.getAttribute('data-line'), 10), Math.max(0, parseInt(i.value, 10) || 0), i);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'Could not add to bag'); return; }
        applySections(res.j.sections);
        toast('Added to your bag');
        open('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var input = b.parentElement.querySelector('input'); if (!input) return;
    e.preventDefault();
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product variant picker ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]'); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var stockEl = root.querySelector('[data-stock]');
    var atc = root.querySelectorAll('[data-atc]');
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

    function formatMoney(cents) {
      var v = (cents / 100);
      var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var comma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
    }
    function selected() {
      return $$('fieldset[data-option]', root).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      $$('fieldset[data-option]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selected(); var v = findVariant(opts);
      markAvailability(opts);
      atc.forEach(function (b) {
        if (!v) { b.disabled = true; b.textContent = 'Unavailable'; }
        else if (!v.available) { b.disabled = true; b.textContent = 'Sold out'; }
        else { b.disabled = false; b.textContent = 'Add to bag'; }
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      }
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !v.available);
        stockEl.textContent = v.available ? 'In stock — ready to ship' : 'Currently sold out';
      }
      if (v.featured_media) showMedia(String(v.featured_media.id));
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    function showMedia(id) {
      var main = root.querySelector('[data-main-media]');
      var thumb = root.querySelector('[data-thumb][data-media-id="' + id + '"]');
      if (!main || !thumb) return;
      main.innerHTML = '<img src="' + thumb.getAttribute('data-full') + '" alt="' + (thumb.getAttribute('data-alt') || '') + '">';
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    root.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option]')) update(); });
    root.addEventListener('click', function (e) { var t = e.target.closest('[data-thumb]'); if (t) { e.preventDefault(); showMedia(t.getAttribute('data-media-id')); } });
    markAvailability(selected());

    // Sticky add to bag on mobile
    var sticky = root.querySelector('.sticky-atc'); var buy = root.querySelector('.buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(buy);
      sticky.querySelector('button').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  /* ---------- Collection sort / filters ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); return; }
    var f = e.target.closest('form[data-filter-form]');
    if (f && e.target.type === 'checkbox') f.submit();
  });

  document.addEventListener('DOMContentLoaded', function () {
    ensureOverlay();
    $$('[data-product-root]').forEach(initProduct);
  });
  document.addEventListener('shopify:section:load', function (e) { $$('[data-product-root]', e.target).forEach(initProduct); });
})();
